import { createSlice } from "@reduxjs/toolkit";
import { getResult } from "../../builders/exam-assessment/exam-result.builder";

const initialState = {
    isResultInformationFilled: false,
    isResultInformationNextClicked: true,
    loading: false,
    examResult: [],
    module: [],
    topic: [],
    resultData: []
}

const resultSlice = createSlice({
    name:'result',
    initialState,
    reducers:{
        resultInformationFilled: (state,action) => {
            state.isResultInformationFilled = action.payload
        },
        resultInformationNextClicked: (state, action) => {
            state.isResultInformationNextClicked = action.payload
        },
        clearExtraReducers : (state) => {
            state.loading = false,
            state.result = [],
            state.module = [],
            state.topic = [],
            state.resultData = []
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getResult.pending, (state)=>{
            state.loading = true,
            state.result = []
        }),
        builder.addCase(getResult.fulfilled, (state, action)=>{
            state.loading = false
            state.result = action.payload
        }),
        builder.addCase(getResult.rejected, (state)=>{
            state.loading = false
        })
    }
})

export const { resultInformationFilled } = resultSlice.actions

export default resultSlice.reducer;